<template>
  <t-form labelWidth="100px">
    <t-form-item label="环境光颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.ambientLightColor" size="small"/>
    </t-form-item>
    <t-form-item label="机柜颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.cabinetColor" size="small"/>
    </t-form-item>
  </t-form>
</template>

<script>
export default {
  name: "cpt-three-server-room-option",
  props: {
    attribute: Object
  },
}
</script>

<style scoped>

</style>
